(function() { module.exports = window["eventespresso"]["hooks"]; }());